import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import CopyLinkIcon from "../../../resource/icon/copy-link.svg"
import ShareDoneIcon from "../../../resource/icon/share-done.svg"
import ShareButton from "./ShareButton"

interface CopyLinkButtonProps {
  order: number
  shareUrl: string
  trackClick: () => void
}

export default function CopyLinkButton({ order, shareUrl, trackClick }: CopyLinkButtonProps) {
  const [copied, setCopied] = useState<boolean>(false)

  const { t } = useTranslation()

  const copyLink = () => {
    trackClick()

    function secondaryCopyMethod() {
      var input = document.createElement('input')
      input.setAttribute('value', shareUrl)
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)

      setCopied(true)
    }

    if (navigator.clipboard) {
      navigator.clipboard.writeText(shareUrl).then(() => {
        setCopied(true)
      }, secondaryCopyMethod)
    } else {
      secondaryCopyMethod()
    }
  }

  return (
    <ShareButton
      order={order}
      onClick={copyLink}
      style={{ backgroundColor: "#343A44" }}
    >
      <img src={copied ? ShareDoneIcon : CopyLinkIcon} />
        {t("shareSheet.buttons.copyLink")}
    </ShareButton>
  )
}
